exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".flash-success,\n.flash-warning,\n.flash-error {\n  border: 1px solid #ccc;\n  display: block;\n  left: 25%;\n  padding: 30px;\n  position: fixed;\n  text-align: center;\n  top: 15%;\n  width: 50%;\n  z-index: 1; }\n\n.flash-success {\n  background-color: #c7f282; }\n\n.flash-warning {\n  background-color: #f1e681; }\n\n.flash-error {\n  background-color: #f08181; }\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 15% auto 0;\n  max-width: 600px; }\n  .auth-form h3,\n  .auth-form input {\n    margin-bottom: 5%; }\n  .auth-form button {\n    align-self: flex-end;\n    max-width: 200px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/App.scss
// module id = 162
// module chunks = 0